import { useEffect, useMemo, useRef, useState } from 'react'
import debounce from 'lodash.debounce'

const DEBOUNCE_DELAY = 500

export default function useDebouncedStateCommit(initialState, commitFunc) {
  const [state, setState] = useState(undefined)

  //initial state is first non undefined value
  useEffect(() => {
    setState((state) => {
      if (state === undefined && initialState) return initialState
      return state
    })
  }, [initialState])

  const first = useRef(true)
  const debouncedCommitFunc = useMemo(() => debounce(commitFunc, DEBOUNCE_DELAY), [])
  useEffect(() => {
    if (state !== undefined) {
      if (!first.current) {
        debouncedCommitFunc(state)
      }
      first.current = false
    }
  }, [state])

  return [state, setState]
}
